import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";

export const SITE_CONFIG = {
  name: "Chatfuse",
  lastUpdated: "",
  description:
    "Automate WhatsApp for your business. Send campaigns, manage contacts, and track results with Chatfuse's powerful automation platform.",
  url: "https://chatfuse.in",
  ogImage: "https://chatfuse.in/og.jpg",
  links: {
    twitter: "https://twitter.in/chatfuse",
    github: "https://github.com/chatfuse",
    linkedin: "https://linkedin.com/company/chatfuse",
  },
};

export const NAVIGATION = [
  { name: "Features", href: "#features" },
  { name: "How It Works", href: "#how-it-works" },
  { name: "Pricing", href: "#pricing" },
  { name: "FAQ", href: "#faq" },
];

export const COLORS = {
  primary: "#22c55e",
  secondary: "#16a34a",
  background: "#161e2d",
  accent: "#15803d",
  success: "#10b981",
  warning: "#f59e0b",
  error: "#ef4444",
  dark: "#1a1a2e",
  light: "#f8f9fa",
  // Additional nav colors
  navBackground: "#ffffff",
  navBorder: "#e2e8f0",
  textPrimary: "#1e293b",
  textSecondary: "#64748b",
  hover: "rgba(34, 197, 94, 0.1)",
  shadow: "rgba(0, 0, 0, 0.1)",
  // Additional UI colors
  sidebar: "#1e293b",
  sidebarLight: "#334155",
  active: "rgba(34, 197, 94, 0.15)",
  border: "#334155",
};

export const CONTACT_DETAILS = {
  phone: "+91 807 297 4576",
  email: "chatfuseteam@gmail.com",
};

export const SOCIAL_LINKS = [
  {
    icon: FaInstagram,
    href: "https://www.instagram.com/chat_fuse/?hl=en",
    label: "Instagram",
  },
  {
    icon: FaLinkedin,
    href: "https://www.linkedin.com/in/chatfuse-team-673b59388/",
    label: "LinkedIn",
  },
  {
    icon: FaTwitter,
    href: "https://x.com/Chat_Fuse",
    label: "Twitter",
  },
  {
    icon: FaFacebook,
    href: "https://www.facebook.com/profile.php?id=61581623113228",
    label: "Facebook",
  },
  // {
  //   icon: FaYoutube,
  //   href: "",
  //   label: "YouTube",
  // },
];
